import { BuilderSegmentService } from '../../services/BuilderSegmentService';
import { BUILDER_AGENT_SETTINGS_SAVED } from '../events';
import { role } from '../types/instructions';
export class AgentSegmentService extends BuilderSegmentService {
    setState(state) {
        this.state = state;
    }
    trackAiAgentBlock(event, payload, success) {
        this.trackEvent(event, {
            ...payload,
            blockId: this.state.id,
            blockName: this.state.$title,
        }, success);
    }
    trackAiAgentConfiguration({ after, before }, success) {
        const payload = {
            before: { ...this.formatSettingsToTracking(before) },
            after: { ...this.formatSettingsToTracking(after) },
            blockId: this.state.id,
            blockName: this.state.$title,
        };
        this.trackAiAgentBlock(BUILDER_AGENT_SETTINGS_SAVED, payload);
    }
    formatSettingsToTracking(configuration) {
        return {
            modelName: configuration.model.model,
            temperature: configuration.model.temperature,
            maxTokens: configuration.model.maxTokens,
            interactionsStored: configuration.prompt.some(item => {
                return item?.type === role.shortTermMemory;
            }),
            responseSend: configuration.output.forward.enabled,
            responseRedirect: configuration.output.forward.handoffName,
            variableName: configuration.output.forward.outputVariable,
            formatType: Object.keys(configuration.output.contentTypes)
                .map(key => configuration.output.contentTypes[key].enabled).filter(item => item).join(', '),
        };
    }
}
